import type { ReactNode } from 'react';

interface SettingsSectionHeaderProps {
  title: string;
  description: ReactNode;
  /** Optional control rendered on the right (e.g. an "Add account" button). */
  action?: ReactNode;
  /** Optional badge rendered next to the title (e.g. "Coming soon"). */
  badge?: ReactNode;
}

export function SettingsSectionHeader({
  title,
  description,
  action,
  badge,
}: SettingsSectionHeaderProps): React.ReactElement {
  return (
    <div className="mb-6 flex items-start justify-between gap-3">
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-bold tracking-wider text-muted-foreground uppercase">{title}</h3>
          {badge}
        </div>
        <p className="mt-1 text-sm text-muted-foreground">{description}</p>
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
